import { AllowResizing } from "@grapecity/wijmo.grid";
import { FlexGrid, FlexGridColumn } from "@grapecity/wijmo.react.grid";
import { css } from "emotion";
import _ from "lodash";
import {
  DocumentCardActivity,
  MessageBar,
  MessageBarType,
} from "office-ui-fabric-react";
import React from "react";
import { useRef } from "react";
import { useEffect } from "react";
import {
  Assign,
  AssignMonthColumn,
  Employee,
  NenkiInfo,
} from "../../../../types/types";
import { nameof } from "../../../../util/util";

export interface EmployeeAssignSummaryProps {
  nenkiInfo: NenkiInfo;
  employee?: Employee;
  assigns?: Assign[];
}

/**
 * 従業員アサインサマリー
 * @param props
 * @constructor
 *
 * TODO: 1人月超過時の色付け
 * TODO: その人でフィルタしたビューを表示する機能
 */
export const EmployeeDetail = ({
  nenkiInfo,
  employee,
  assigns,
}: EmployeeAssignSummaryProps) => {
  const detailGridRef: any = useRef(null);

  useEffect(() => {
    if (detailGridRef.current) {
      const elem: HTMLElement = detailGridRef.current.control.hostElement;
      elem.style.height = "184px";
      // https://demo.grapecity.com/wijmo/demos/Grid/Columns/Collections/react
      detailGridRef.current.control.rowHeaders.columns.splice(0, 1);
    }
  }, []);

  let myAssigns: Assign[] = [];

  if (employee && assigns) {
    myAssigns = assigns.filter((v) => v.inChargeUsername === employee.username);
  }

  return (
    <>
      {(() => {
        if (employee) {
          return (
            <DocumentCardActivity
              activity={employee.groupName}
              people={[
                {
                  name: employee.fullName,
                  profileImageSrc: "",
                  initials: employee.fullName.substring(0, 1),
                },
              ]}
            />
          );
        } else {
          return (
            <MessageBar messageBarType={MessageBarType.warning}>
              担当者未設定
            </MessageBar>
          );
        }
      })()}
      <div
        className={css`
          padding: 10px 10px 10px 10px;
        `}
      >
        <FlexGrid
          ref={detailGridRef}
          autoGenerateColumns={false}
          itemsSource={getPersonAssignSummary(nenkiInfo, myAssigns)}
          isReadOnly={true}
          allowResizing={AllowResizing.None}
          allowSorting={false}
          stickyHeaders={true}
          selectionMode={"None"}
          alternatingRowStep={0}
        >
          <FlexGridColumn header="月" binding="month" width={"*"} />
          <FlexGridColumn
            header="アサイン"
            binding="assign"
            width={80}
            format={"F2"}
          />
          <FlexGridColumn header="ジョブ数" binding="jobCount" width={80} />
        </FlexGrid>
      </div>
    </>
  );
};

const getPersonAssignSummary = (nenkiInfo: NenkiInfo, ap: Assign[]) => {
  return nenkiInfo.months.map((month) => ({
    month: `${month.month}月`,
    assign: _.sumBy(ap, nameof<AssignMonthColumn>(month.columnName)),
    jobCount: ap.filter((v) => v[month.columnName]).length,
  }));
};
